/**
 * Product feature toggles — values come from VITE_ENABLE_* in .env.{dev|stg|prod|test}.
 */
const normalizeFlag = (value?: string) => value?.trim().toLowerCase();

const isEnabled = (value?: string) => normalizeFlag(value) === 'true';

export const isGroupChatEnabled = isEnabled(import.meta.env.VITE_ENABLE_GROUP_CHAT);
export const isIncognitoChatEnabled = isEnabled(import.meta.env.VITE_ENABLE_INCOGNITO_CHAT);
export const isVoiceCallEnabled = isEnabled(import.meta.env.VITE_ENABLE_VOICE_CALL);

export const FEATURE_FLAGS = {
  groupChat: isGroupChatEnabled,
  incognitoChat: isIncognitoChatEnabled,
  voiceCall: isVoiceCallEnabled,
} as const;
